import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";

import Button from '@mui/material/Button';

interface ShowAnswerProps {
    question: any;
    optionalContext?: string;
    answer?: any;
}

const ShowAnswer = observer(
    ({
        answer,
        question,
        optionalContext,
    }: ShowAnswerProps) => {
        let replaceUnderlines = function(text: string) {
            if (!text) return '';

            while (text.includes("__")) {
                text = text.replace('__', '<span class="chunk-answer-word">');
                text = text.replace('__', '</span>');                
            }

            return text;
        }

        let answer_text = '';
        if (answer) {
            answer_text = answer.text;
        }

        let question_text = question.text;

        let showCorrect = <div></div>

        if (answer.isCorrect != undefined) {
            question_text = answer.correctAnswer;
            if (answer.isCorrect) {
                showCorrect = <div>Right!</div>
            } else {
                showCorrect = <div>Wrong!</div>
            }
            if (answer.givenAnswer) {
                question_text = answer.givenAnswer;
                answer_text = `The correct answer would have been: ${answer.correctAnswer}` 
            } else {
                answer_text = '';
            }
        }
        
        return (
            <div>
                {optionalContext && optionalContext.length > 0 ? <div className="optional-context text-muted">{optionalContext}</div> : <span></span>}
                <div className="question-text text-muted">{question_text}</div>
                {showCorrect}
                <br />
                <br />
                <div className="answer-text"
                        dangerouslySetInnerHTML={{
                            __html : replaceUnderlines(answer_text)
                        }} />
            </div>
        );
    }
);

export default ShowAnswer;